<script>
	// 빌더 좌측 섹션 네비게이션. 탭 상태는 호출부가 소유 — 여긴 표현만.
	// chat-builder/shell/BuilderSidebar.svelte 와 같은 규격(레일 56px → 풀 220px)이다.
	import { createEventDispatcher } from "svelte";

	export let tabList = [];
	export let currentTab = "";

	const dispatch = createEventDispatcher();

	// lucide 스타일 아이콘(내부 마크업만; svg 래퍼는 공통)
	const icons = {
		map: '<path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3z"/><path d="M9 3v15"/><path d="M15 6v15"/>',
		character: '<path d="M12 2 4 7v10l8 5 8-5V7z"/><path d="M12 22V12"/><path d="m4 7 8 5 8-5"/>',
		asset:
			'<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="1.6"/><path d="m21 15-3.6-3.6a2 2 0 0 0-2.8 0L6 21"/>',
		pattern:
			'<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
		skill: '<path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z"/>',
		tuning:
			'<line x1="4" x2="4" y1="21" y2="14"/><line x1="4" x2="4" y1="10" y2="3"/><line x1="12" x2="12" y1="21" y2="12"/><line x1="12" x2="12" y1="8" y2="3"/><line x1="20" x2="20" y1="21" y2="16"/><line x1="20" x2="20" y1="12" y2="3"/><line x1="1" x2="7" y1="14" y2="14"/><line x1="9" x2="15" y1="8" y2="8"/><line x1="17" x2="23" y1="16" y2="16"/>',
		main: '<rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" x2="16" y1="21" y2="21"/><line x1="12" x2="12" y1="17" y2="21"/>',
		design:
			'<circle cx="13.5" cy="6.5" r=".5"/><circle cx="17.5" cy="10.5" r=".5"/><circle cx="8.5" cy="7.5" r=".5"/><circle cx="6.5" cy="12.5" r=".5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.9 0 1.6-.7 1.6-1.6 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1a1.6 1.6 0 0 1 1.6-1.6h2c3 0 5.6-2.5 5.6-5.6C22 6 17.5 2 12 2z"/>',
		sound: '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.1 4.9a10 10 0 0 1 0 14.2M15.5 8.5a5 5 0 0 1 0 7.1"/>',
		share:
			'<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" x2="15.4" y1="13.5" y2="17.5"/><line x1="15.4" x2="8.6" y1="6.5" y2="10.5"/>',
	};
</script>

<!-- 폰(<md=768px)은 상단 가로 탭(GameBuilderTopTabs)으로 대체 → 여기선 숨김.
     태블릿(md~lg)은 아이콘 레일(56px), 데스크톱(≥lg=1024px)은 풀 사이드바(220px). -->
<aside class="tw-hidden tw-w-14 tw-shrink-0 tw-flex-col tw-border-r tw-border-border tw-bg-sidebar tw-font-sans md:tw-flex lg:tw-w-[220px]">
	<nav class="tw-flex tw-flex-1 tw-flex-col tw-gap-1 tw-px-2 tw-pt-4 lg:tw-px-3">
		<div class="tw-hidden tw-px-2 tw-pb-1 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground lg:tw-block">
			빌더 단계
		</div>
		{#each tabList as tab (tab.value)}
			<button
				type="button"
				title={tab.label}
				class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-lg tw-px-2.5 tw-py-2 tw-text-left tw-text-sm tw-transition-colors lg:tw-justify-start {currentTab ===
				tab.value
					? 'tw-bg-primary/10 tw-font-semibold tw-text-primary'
					: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
				on:click={() => dispatch("change", tab.value)}
			>
				<svg
					class="tw-h-[18px] tw-w-[18px] tw-shrink-0"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					{@html icons[tab.value] || ""}
				</svg>
				<span class="tw-hidden tw-flex-1 lg:tw-block">{tab.label}</span>
			</button>
		{/each}
	</nav>
</aside>
